export const RemoveIcon = ({
  onClick,
  width,
  height,
  fill,
  crossFill,
}: {
  onClick?: () => void
  width?: number
  height?: number
  fill?: string
  crossFill?: string
}) => (
  <svg
    width={width || 20}
    height={height || 20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <circle cx="10" cy="10" r="10" fill={fill || 'none'} />
    <path
      d="M6.96963 6.96965C7.26252 6.67676 7.73739 6.67676 8.03029
       6.96965L9.99997 8.93933L11.9696 6.96967C12.2625 6.67678 12.7374 6.67678 13.0303
       6.96967C13.3232 7.26256 13.3232 7.73744 13.0303 8.03033L11.0606 9.99999L13.0303
       11.9696C13.3232 12.2625 13.3232 12.7374 13.0303 13.0303C12.7374 13.3232 12.2625
       13.3232 11.9696 13.0303L9.99997 11.0607L8.03031 13.0303C7.73742 13.3232 7.26254
       13.3232 6.96965 13.0303C6.67676 12.7374 6.67676 12.2625 6.96965
       11.9697L8.93931 9.99999L6.96963 8.03031C6.67673 7.73742 6.67673 7.26254 6.96963 6.96965Z"
      fill={crossFill || '#FF001F'}
    />
  </svg>
)
